import MailIcon from '@material-ui/icons/Mail';

import MailTemplateList from './MailTemplateList';
import MailTemplateCreate from './MailTemplateCreate';
import MailTemplateEdit from './MailTemplateEdit';

export default {
  list: MailTemplateList,
  create: MailTemplateCreate,
  edit: MailTemplateEdit,
  icon: MailIcon
};
